import React from 'react';
import { Link } from 'react-router-dom';
import './HowItWorks.css';

function HowItWorks() {
    return (
        <div className="howitworks-container">
            <div className="howitworks-title">How It Works</div>
            <div className="howitworks-options-container">
                <div className="howitworks-option howitworks-option-coming-soon">
                <div className="howitworks-option-title">Rates</div>
                    <div className="howitworks-option-subtitle">
                    All humans enter free! Must be 21+ years old.
                    </div>
                    {/* Coming Soon Mode: Links are disabled but card remains visible */}
                    {/* TODO: Remove coming-soon-overlay and enable links when business opens */}
                    <div className="coming-soon-overlay">
                        <div className="coming-soon-text">Coming Soon!</div>
                    </div>
                    <Link 
                        to="/Dog-Passes" 
                        className="howitworks-dollarsign"
                        onClick={(e) => {
                            e.preventDefault();
                            return false;
                        }}
                        style={{ pointerEvents: 'none', opacity: 0.6 }}
                    >
                        <img
                            src="./dollarsign.png"
                            alt="$"
                        />
                    </Link>
                    <Link 
                        to="/Dog-Passes"
                        onClick={(e) => {
                            e.preventDefault();
                            return false;
                        }}
                        style={{ pointerEvents: 'none', opacity: 0.6 }}
                    >
                        <button className="howitworks-option-button" disabled>View Our Dog Pass Prices</button>
                    </Link>
                </div>
                <div className="howitworks-ampersand">
                    <img 
                        src="./ampersand.png"
                        alt="&"
                    />
                </div>
                <div className="howitworks-option">
                    <div className="howitworks-option-title rules">Rules</div>  
                    <div className="howitworks-option-subtitle">
                    Please review our Parks & Bars Rules. For families bringing children, both our Park Rules and <Link to="/Dog-House-Rules" className="family-guidelines-link">Family Guidelines</Link> apply, and waivers must be signed in person for both.
                    </div>
                     <Link to="/Rules" className="howitworks-rulesheet">
                        <img 
                          src="./rulesheet.png"
                          alt="rules"
                        />
                     </Link>
                    <Link to="/Rules"><button className="howitworks-option-button">View Our Park Rules</button></Link>
                </div>
            </div>
        </div>
    )
}

export default HowItWorks;